import img1 from './ServicesImages/undraw_work_img1.svg'
import img2 from './ServicesImages/ecommers img2.svg'
import img3 from './ServicesImages/undraw_firmwar_img3.svg'
import img4 from './ServicesImages/undraw_financial_img4.svg'
import img5 from './ServicesImages/online_learning_img5.svg'
import img6 from './ServicesImages/undraw_product_img6.svg'
import img7 from './ServicesImages/mobile_img7.svg'
import img8 from './ServicesImages/undraw_operating_system_img88.svg'
import img9 from './ServicesImages/undraw_programming_re_kg9v.svg'



export const services = [
    {
        img: img6,
        title: "PRODUCT ENGINEERING",
        parag: "Ideation & Conceptualization; Business Analysis; Architecture & Design; Development; Test Automation; Release Management & DevOps; Sustained Engineering & Support",
    },
    {
        img: img9,
        title: "PENETRATION TESTING",
        parag: "We run exploits and dummy attacks to evaluate the network’s security. To achieve a high degree of penetration, we use advanced tools and open-source scripts."
    },
    {
        img: img1,
        title: "INFRASTRUCTURE MANAGEMENT",
        parag: "OnPrem Infra Management, Cloud Management, Hybrid Management, Database Management, Network & Storage Management, Backup & Recovery Management."
    },
    {
        img: img2,
        title: "ECOMMERCE",
        parag: "eCommerce Product Development and Integration; eCommerce,Platform Analysis, Fitment, Recommendations; eCommerce Platform Services and Implementation; Omni-Channel Implementation."
    },
    {
        img: img3,
        title: "BUSINESS INTELLIGENCE",
        parag: "Data Sources Management; Data Warehousing; Real-time BI; Corporate Performance Management( CPM); OLAP (Online Analytical Processing)"
    },
    {
        img: img4,
        title: "ENTERPRISE APPLICATIONS & DATA ARCHITECTURE",
        parag: "Business Centric Architecture; Smart & Adaptable; Collaboration & Governance; Secure & Resilient; Robust & Scalable; Centralized Management"
    },
    {
        img: img5,
        title: "E-LEARNING",
        parag: "Interactive Web-Based Learning; Simulation Based Learning; Scenario Based Learning; Gamification; SaaS Application Offerings; Individual Applications; Custom Learning Modules",
    },
    {
        img: img7,
        title: "MOBILE APPLICATIONS",
        parag: "Mobile App Development; Cross Platform; UI/ UX and Security; Digital Innovation; Connecting across touchpoints",
    },
    {
        img: img8,
        title: "SOFTWARE AS A SERVICE OFFERING",
        parag: "SaaS offerings for Education Institutes, Medical Facilities, Groceries, Essential Goods and MSMEs.",
    },

]